import { Component, ElementRef, HostListener, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { Observable, map, of } from "rxjs";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'app-school-dashboard',

  templateUrl: './school-dashboard.component.html',

  styleUrls: ['./school-dashboard.component.css'],
    
})

export class SchoolDashboardComponent implements OnInit {

  iMobileDomain: string = '-1';

  ctxChart: any;

  ctxChart2: any;

  ctxChart3: any;

  ctxChart4: any;

  ctxChart5: any;

  options!: Observable<any>;

  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };


  constructor(

    private router: Router,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService


  ) { Chart.register(zoomPlugin); }

  ngOnInit(): void {

    this.getCharts(this.iMobileDomain);

  }
  
  async getCharts(iMobileDomain: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    this.ticket_ChartBase(model);

    this.ticket_BaseSubject(model);

    this.ticket_BaseStatus(model);

    this.loadTree1('School_Tree_TiketSubjectStatus');

    this.bestStudent(model);

    this.worstStudent(model)


  }

  async ticket_ChartBase(model: any) {

    let res = JSON.parse(((await axios.post(`School_Tiket_ChartBaseSchool4School`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart1') as any;

    if (this.ctxChart) this.ctxChart.destroy();

    this.ctxChart = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }

  async ticket_BaseSubject(model: any) {

    let res = JSON.parse(((await axios.post(`School_Tiket_ChartBaseSchool4School_BaseSubject`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    if (this.ctxChart2) this.ctxChart2.destroy();

    this.ctxChart2 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async ticket_BaseStatus(model: any) {

    let res = JSON.parse(((await axios.post(`School_Tiket_ChartBaseSchool4School_BaseStatus`, model)).data.toString()));

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    res.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart3") as any;

    var ctx = canvas.getContext("2d");

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS),

        },

      ],

    } as any;

    if (this.ctxChart3) this.ctxChart3.destroy();

    this.ctxChart3 = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {

                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        onClick: (e) => {

          const points = this.ctxChart3.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

          const firstPoint = points[0];

          const label = this.ctxChart3.data.labels[firstPoint.index];

        },
        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

    var chartEl = document.getElementById("myChart3") as any;

    chartEl.height = 200;

  }

  async loadTree1(api: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    };

    const resp = await axios.post(`${api}`, model);

    this.options = of(resp.data)

      .pipe(

        map((data: any) => {

          let res = JSON.parse(data.toString());

          let not = 0;

          res.children.forEach((element: any) => {

            not += element.children.length

          });


          if (not > 50) {

            let can = document.getElementById('totalVehicles') as HTMLElement;

            can.style.height = '700px'

          }


          res.children.forEach(function (datum: any, index: number) {

            index % 1 === 0 && (datum.collapsed = true);

          });

          return {

            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  async bestStudent(model: any) {

    let res = JSON.parse(((await axios.post(`School_Encouragement_BestStudents`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart4') as any;

    if (this.ctxChart4) this.ctxChart4.destroy();

    this.ctxChart4 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }

  async worstStudent(model: any) {

    let res = JSON.parse(((await axios.post(`School_Encouragement_Worst`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart5') as any;

    if (this.ctxChart5) this.ctxChart5.destroy();

    this.ctxChart5 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }


  goBack() {

    this.router.navigateByUrl('')

  }

}
